// History and Diagnoses subsection form field enum
export enum HistoryAndDiagnosesFormField {
  PRIMARY_DIAGNOSES = 'patientBackground/primaryDiagnoses',
  OTHER_DIAGNOSES = 'patientBackground/otherDiagnoses',
  THERAPIES = 'patientBackground/therapies',
  EQUIPMENT = 'patientBackground/equipment',
  EQUIPMENT_OTHER = 'patientBackground/equipmentOther',
  PCP = 'patientBackground/pcp',
  ER_QUESTION = 'patientBackground/erQuestion',
  ER_NOTES = 'patientBackground/erNotes',
  HOSPITAL_QUESTION = 'patientBackground/hospitalQuestion',
  HOSPITAL_NOTES = 'patientBackground/hospitalNotes',
  INJURIES_QUESTION = 'patientBackground/injuriesQuestion',
  INJURIES_NOTES = 'patientBackground/injuriesNotes',
  FALLS_QUESTION = 'patientBackground/fallsQuestion',
  FALLS_NOTES = 'patientBackground/fallsNotes',
  INFECTIONS_QUESTION = 'patientBackground/infectionsQuestion',
  INFECTIONS_NOTES = 'patientBackground/infectionsNotes',
  MD_QUESTION = 'patientBackground/mdQuestion',
  MD_NOTES = 'patientBackground/mdNotes'
}
